// extracted by mini-css-extract-plugin
export var active = "_j-8";
export var addWidgetButton = "_j-9";
export var backButton = "_j-1";
export var pageContainer = "_j-2";
export var settingsContent = "_j-0";
export var sideNavContainer = "_j-6";
export var sideNavLink = "_j-7";
export var widgetContainer = "_j-5";
export var widgetSubsectionItem = "_j-3";
export var widgetSubsectionItemContent = "_j-4";